import { Modal, ModalProps, Row } from 'antd';

interface ComponentProps extends ModalProps {
  icon?: React.ReactNode;
  content: React.ReactNode;
}

const ModalComponent = (props: ComponentProps) => {
  const { icon, title, content } = props;
  return (
    <Modal
      maskClosable={false}
      keyboard={false}
      centered
      {...props}
      title={
        <Row align="middle">
          {icon && <span className="icon">{icon}</span>}
          <span className="title">
            {title}
          </span>
        </Row>
      }
    >
      {content}
    </Modal>
  );
};

export default ModalComponent;
